export default __webpack_public_path__ + "images/efba3f8cf0895e39519f11757a7224d3-fighterHelicopter1.png";